import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useWorkspace } from '../../../context/WorkspaceContext';
import { useProject } from '../../../context/ProjectContext';
import { fetchLastWorkspaceDashboardTarget } from '../../../utils/authRedirectUtils';
import { RtModal } from '../../ui/RtModal';

// Save & Exit confirmation for users who already completed the wizard:
// they stay logged in and continue from the application instead of resuming onboarding later.
const LeaveWizardModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { selectWorkspace } = useWorkspace();
  const { selectProject } = useProject();
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleLeave = async () => {
    setIsLoading(true);

    try {
      const { path, lastWorkspace, lastProject } = await fetchLastWorkspaceDashboardTarget();

      if (lastWorkspace?.id && lastProject?.project_id) {
        selectWorkspace(lastWorkspace);
        selectProject(String(lastProject.project_id), lastProject.project_name || '');
      }

      onClose();
      navigate(path);
    } catch (error) {
      console.error('Failed to resolve dashboard path:', error);
      onClose();
      navigate('/dashboard');
    }
  };

  return (
    <RtModal
      open={isOpen}
      onClose={onClose}
      title="Leave Setup?"
      size="sm"
      variant="confirm"
      closeDisabled={isLoading}
      closeOnBackdrop={!isLoading}
      footer={
        <>
          <button
            type="button"
            className="rt-btn rt-btn--secondary"
            onClick={handleLeave}
            disabled={isLoading}
          >
            {isLoading ? 'Leaving…' : 'Leave'}
          </button>
          <button
            type="button"
            className="rt-btn rt-btn--primary"
            onClick={onClose}
            disabled={isLoading}
          >
            Stay
          </button>
        </>
      }
    >
      <div className="rt-modal-confirm">
        <p className="rt-modal-confirm__message">Do you want to leave this flow?</p>
        <p className="rt-modal__hint">
          You can proceed with the further flow from the application.
        </p>
      </div>
    </RtModal>
  );
};

export default LeaveWizardModal;
